import React from 'react'
import { MenuItem } from 'react-aria-components'

import { env } from '@/shared/config'
import { useActiveLaw } from '@/shared/lib/cookieyes/provider/use-active-law'
import { SelectCookiesButton } from '@/shared/lib/cookieyes/select-cookies-button'
import { useI18n } from '@/shared/lib/i18n'
import { getLegalLinkHref } from '@/shared/lib/legal-link'

import { navbarMenu } from '../styles/recipe'

export function LegalLinks() {
    const { i18n, lang } = useI18n()
    const classes = navbarMenu()
    const activeLaw = useActiveLaw()

    return (
        <React.Fragment>
            <MenuItem
                className={classes.item}
                href={getLegalLinkHref(lang, 'terms-of-service/')}
                target="_blank"
                rel="noreferrer"
            >
                {i18n.LINK_LEGAL_TERMS}
            </MenuItem>
            <MenuItem
                className={classes.item}
                href={getLegalLinkHref(lang, 'privacy-policy/')}
                target="_blank"
                rel="noreferrer"
            >
                {i18n.LINK_LEGAL_PRIVACY}
            </MenuItem>

            {env.COOKIEYES_SITE_ID && activeLaw && (
                <MenuItem className={classes.item}>
                    <SelectCookiesButton />
                </MenuItem>
            )}

            <MenuItem
                className={classes.item}
                href={getLegalLinkHref(lang, 'cookies/')}
                target="_blank"
                rel="noreferrer"
            >
                {i18n.LINK_LEGAL_COOKIES}
            </MenuItem>

            {lang === 'de' && (
                <MenuItem
                    className={classes.item}
                    href={getLegalLinkHref(lang, 'impressum/')}
                    target="_blank"
                    rel="noreferrer"
                >
                    {i18n.LINK_IMPRESSUM}
                </MenuItem>
            )}

            {lang === 'ja' && (
                <MenuItem
                    className={classes.item}
                    href={getLegalLinkHref(lang, 'notation/')}
                    target="_blank"
                    rel="noreferrer"
                >
                    {i18n.LINK_NOTATION_JP}
                </MenuItem>
            )}
        </React.Fragment>
    )
}
